<template>
  <div :class="['barItem', type, { active: isActive, withRedPoint }]" @click="gotoPage(type)">
    {{ txt }}
  </div>
</template>

<script setup lang="ts">
  import { useActivityList } from '@/store'
  import { storeToRefs } from 'pinia'
  import { useI18n } from 'vue-i18n'

  const { type } = defineProps<{
    type: string;
  }>()

  const { t } = useI18n()

  const txts = {
    deposito: '',
    servico: t('barItem.servico'),
    meu: t('barItem.meu'),
    home: t('barItem.home'),
    promocao: t('barItem.promocao'),
  }

  const txt = computed(() => {
    return txts[type]
  })

  const { activityList } = storeToRefs(useActivityList())
  const withRedPoint = computed(() => {
    return type == 'promocao' && activityList.value.some(item => item.rewardStatus == 'Awarded')
  })

  const route = useRoute()

  const isActive = route.path.startsWith('/' + type)

  const router = useRouter()
  const gotoPage = (type: string) => {
    router.push('/' + type)
  }
</script>

<style scoped lang="scss">
.barItem {
  flex: 1;
  height: 100%;
  position: relative;
  background: no-repeat center 5px / 34px;
  padding-top: 38px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  font-weight: 400;

  &.active{
    color: var(--theme-primary);
  }

  &.withRedPoint::after{
    top: 10px;
    left: 70%;
  }
}
</style>
